/**
 * Constants used throughout the application.
 */

// List of locations that use the custom video pipeline.
export const AVAILABLE_FILTERS = ['24h', '1h', '30min', '15min', '5min'];
export const KINESIS_VIDEO_LOCATIONS = ['38', '40', '41', '104', '111', '119', '120', '121',
    '122', '134', '135', '136', '137', '139', '141', '143', '144', '145', '149', '175', '175',
    '176', '177', '179', '180', '181', '187', '189', '190', '192', '193', '194', '195', '196',
    '197', '198', '199', '200', '201', '202', '203', '226', '274', '275', '276', '288', '289',
    '290', '291', '292', '293', '294', '295', '296', '297', '298', '299', '300', '301', '302',
    '303', '304', '305', '306', '307', '308', '309', '310', '311', '312', '313', '314', '315',
    '317', '318', '319', '321', '322', '323', '324', '325', '326', '327', '333', '335', '337',
    '338', '341', '342', '343', '345', '346', '347', '348', '349', '350', '383', '384', '392',
    '393', '394', '399', '400', '401', '402', '403', '419', '444', '445', '446', '478', '479',
    '480', '481', '513', '513', '514', '515', '516', '560', '561', '562', '563', '573', '574',
    '595', '596', '635', '636', '637', '638', '639', '640', '657', '664', '665', '679', '680', '1731', '1732'];
export const PANDAFRANCHISE = '59';
export const TACOBELLFRANCHISE = '64';
export const JCKFRANCHISE = '26';
export const SNLFRANCHISE = '29';
export const MONITORSTREAMSENABLED = ['6', '59'];
export const REPORTSENABLED = [SNLFRANCHISE];
export const CVDTENABLED = [TACOBELLFRANCHISE, JCKFRANCHISE];

export const FLAGS = [
    'HighCost', // order total over $50
    'NoCost', // order total less than or equal to $0
    'ZeroTender', // no cash amount tendered
    'HighChange', // order change greater than or equal to $50
    'LowTax', // tax less than 4% of total
    'OffHours', // 12AM - 8AM
    'Discounts', // order with a discount applied
];

// detection + notification type for notification service and user preference
export enum NotificationType {
    DT_SOS = 'DT_SOS',
    DT_AVG_SOS = 'DT_AVG_SOS',
    LOBBY_VOL = 'LOBBY_VOL',
    LOBBY_OPEN = 'LOBBY_OPEN',
    LOBBY_LATE = 'LOBBY_LATE',
    LOBBY_CLOSE = 'LOBBY_CLOSE',
    QUEUE_VOL = 'QUEUE_VOL',
};

export const NotificationDisplayMap = {
    DT_SOS: 'Latest Drive Thru Speed',
    LOBBY_VOL: 'Lobby Customer Count',
    QUEUE_VOL: 'Drive Thru Line Count',
    DT_AVG_SOS: 'Average Drive Thru Speed',
    LOBBY_OPEN: 'Lobby Open Time',
    LOBBY_CLOSE: 'Lobby Early Close',
    LOBBY_LATE: 'Lobby Late Open',
};

export const ISO_DATE_DEFAULT = '1970-01-01T00:00:00Z';
